import {
  DeleteHarmReportsResponse,
  GetHarmReportsByFilterResponse,
  HarmReport,
  ReportStatus,
} from '@inplay/models';
import { ReactNode } from 'react';

export type HarmReportProps = {};
export type HarmReportsTableHeaderProps = {
  selectedCount: number;
  searchQuery: string;
  handleOnChangeSearch: (query: string) => void;
  selectedDate: Date | undefined;
  handleSelectedDate?: (date: Date) => void;
  handleReportHarmClick?: () => void;
  onSettingMenuSelect?: (label: string | undefined) => void;
  disableSettingMenu?: boolean;
  children?: ReactNode;
  reportLabel?: string;
  handleClose?: () => void;
  handleDelete?: () => void;
  handleDownload?: () => void;
  showDownloadLoading?: boolean;
};

export type HarmReportsTableFilterProps = {
  selectedBranchIDs: string[];
  isOpenUserModal: boolean;
  handleClearFilters: () => void;
  handleApplyFilters: (filters: any) => void;
  toggleFilterModal: (value: boolean) => void;
};

export enum HarmReportsTableHeader {
  REPORT_NO = 'Report No.',
  NO = 'No.',
  CREATED_ON = 'Created On',
  PLAYER_NO = 'Player No.',
  HARM_OBSERVED = 'Harm Observed',
  INTERVENTION_DECISION = 'Intervention Decision',
  INTERVENTION_STATUS = 'Intervention Status',
  CREATED_BY = 'Created By',
  REVIEWED_BY = 'Reviewed By',
  ACTIONS = 'Actions',
}

export enum SweepTableHeader {
  SWEEP_NO = 'Sweep No.',
  NO = 'No.',
  STATUS = 'Status',
  SWEEP_TYPE = 'Sweep Type',
  TIME = 'Time',
  HOUR = 'Hour',
  NO_OF_PLAYER = 'No. of players',
  HARM_OBSERVED = 'Harm observed',
  COMPLETED_BY = 'Completed by',
  REVIEWED_BY = 'Reviewed by',
  ACTION = 'Actions',
}

export enum HarmReportsKebabOption {
  VIEW = 'View',
  EDIT = 'Edit',
  REVIEW_AND_SIGN = 'Review and Sign',
  DOWNLOAD = 'Download',
  HISTORY = 'History',
  DELETE = 'Delete',
}

export enum HarmReportsPendingAction {
  CREATE_HARM_REPORT = 'CREATE_HARM_REPORT',
  DELETE_REPORTS = 'DELETE_REPORTS',
  EDIT_REPORT = 'EDIT_REPORT',
  DOWNLOAD_REPORTS = 'DOWNLOAD_REPORTS',
}

export type HarmReportsFilteredData = {
  selectedDate: Date;
  searchQuery: string;
};

export type HarmReportsFilter = {
  searchQuery: string;
  selectedDate: Date;
  dateCreated?: Date;
  timeCreated?: string;
  playerNo?: string;
  harmObserved?: string;
  status?: ReportStatus[];
};

export type GetHarmReportsResponse = {
  statusCode: number;
  status: string;
  message: string;
  data: GetHarmReportsByFilterResponse;
};

export type DeleteHarmReportResponse = {
  statusCode: number;
  status: string;
  message: string;
  data: DeleteHarmReportsResponse;
};

export type HarmReportDetailsProps = {
  harmReport: HarmReport;
  closeHarmReportDetails: () => void;
  handleReviewAndSignClick: () => void;
  onKebabAction?: (action: HarmReportsKebabOption) => void;
};

export type DetailSectionProps = {
  title: string;
  children: ReactNode;
  className?: string;
  columns?: number;
};

export type DetailFieldProps = {
  label: string;
  value: string | number | boolean | Date | undefined;
  className?: string;
  flexBasis?: string;
};

export type StatusIndicatorProps = {
  label: string;
  status: string;
  dotColor: string;
};

export type SignatureSectionProps = {
  signature: string | undefined;
  firstName: string;
  lastName: string;
  date: Date | undefined;
  altText: string;
};

export type HarmSignsListProps = {
  title: string;
  items: string[];
};
